import ProformaInvoiceEntity from 'src/db/entities/proforma_invoice/ProformaInvoiceEntity';

type InvoiceRef = Pick<ProformaInvoiceEntity, 'uuid' | 'invoiceId' | 'priceProposalId'>;

/**
 * Invoices (other than `currentInvoiceId`) already linked to the quote.
 * `invoices` is the local list, which holds live invoices only.
 */
export const getOtherInvoicesForQuote = <T extends InvoiceRef>(
  invoices: T[],
  quoteId: string | null | undefined,
  currentInvoiceId?: string | null
): T[] => {
  if (!quoteId) return [];
  return invoices.filter((x) => x.priceProposalId === quoteId && x.uuid !== currentInvoiceId);
};

/** Uuids of the quotes that already have an invoice other than `currentInvoiceId`. */
export const getInvoicedQuoteIds = (
  invoices: InvoiceRef[],
  currentInvoiceId?: string | null
): Set<string> =>
  new Set(
    invoices
      .filter((x) => x.priceProposalId && x.uuid !== currentInvoiceId)
      .map((x) => x.priceProposalId as string)
  );

/** Invoice numbers to show in the warning, e.g. "PRO-2026-78, PRO-2026-79". */
export const formatInvoiceNumbers = (invoices: InvoiceRef[]): string =>
  invoices.map((x) => x.invoiceId ?? '#').join(', ');
